import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footer: {
    height: '8vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  button: {
    backgroundColor: theme?.designer?.primaryButtonBackgroundColor,
    color: theme?.designer?.primaryButtonTextColor,
    width: '47%',
    boxShadow: 'none',
  },
  secondaryButton: {
    backgroundColor: theme?.designer?.secondaryButtonBackgroundColor,
    color: theme?.designer?.secondaryButtonTextColor,
    borderColor: theme?.designer?.secondaryButtonBorderColor,
    width: '47%',
    boxShadow: 'none',
  },
}));

export default useStyles;
